var map = {
	"./bird.jpg": 60057,
	"./boy 01.jpg": 88867,
	"./boy.jpg": 54876,
	"./deer 1.jpg": 38337,
	"./doll.jpg": 92107,
	"./duck.jpg": 19183,
	"./elephant.jpg": 307,
	"./flowers.jpg": 82590,
	"./honey bee.jpg": 45471,
	"./lion.jpg": 22974,
	"./penguin.jpg": 49982,
	"./rab.jpg": 31409,
	"./rabbit 1.jpg": 22433,
	"./rabbit 2.jpg": 32854,
	"./rat.jpg": 58575,
	"./zerafee.jpg": 28626
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89822;